export default () =>
  Math.random()
    .toString(36)
    .substring(2)
